import 'css-chunk:../../src/features/user-settings/components/settings-modal/index.module.scss';export default {
  "sections": "_sections_hytol_1"
};